import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { flagEmoji } from "@/lib/country";

/* 🌍 Live "traders by country" strip — REAL accounts only. Follows the
   leaderboard reset: scope="daily" counts since 00:00 UTC, "weekly" since
   Monday. `only` limits flags to given country codes (e.g. leaderboard
   countries); `max` caps the row so it never becomes a messy flag wall. */
const TradersByCountry = ({ className = "", scope = "daily", only = null, max = 6 }) => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let stop = false;
    const load = () => api.get(`/presence/stats?scope=${scope}`).then((r) => { if (!stop) setStats(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { stop = true; clearInterval(t); };
  }, [scope]);
  if (!stats || !stats.total) return null;
  let list = stats.countries;
  if (only) {
    const allowed = new Set(only.filter(Boolean).map((c) => String(c).toUpperCase()));
    list = list.filter((c) => allowed.has(String(c.country).toUpperCase()));
  }
  const shown = list.slice(0, max);
  const extra = list.length - shown.length;
  return (
    <div data-testid="traders-by-country" className={`flex items-center gap-2 flex-wrap text-[10px] font-mono text-vts-silver/70 ${className}`}>
      <span className="px-1.5 py-0.5 rounded bg-vts-surface border border-vts-line font-bold text-white/80">
        🌍 {stats.total} trader{stats.total === 1 ? "" : "s"} {scope === "weekly" ? "this week" : "today"}
      </span>
      {shown.map((c) => (
        <span key={c.country} data-testid={`country-count-${c.country}`} className="inline-flex items-center gap-0.5">
          <span className="text-[12px] leading-none">{flagEmoji(c.country)}</span>
          <span className="font-bold text-white/70">{c.count}</span>
        </span>
      ))}
      {extra > 0 && (
        <span data-testid="country-count-more" className="px-1 py-0.5 rounded bg-vts-surface border border-vts-line text-white/50">+{extra} more</span>
      )}
    </div>
  );
};

export default TradersByCountry;
